var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content bill-overseas-s-center-view" },
    [
      _c(
        "div",
        { staticClass: "main-content", attrs: { type: "primary" } },
        [
          _c(
            "query-bill-actual-amount-condition",
            { ref: "queryBillActualAmountCondition" },
            [
              _c("template", { slot: "operations" }, [
                _c(
                  "div",
                  { staticStyle: { float: "left" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.toQuery()
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " "
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.sendOfficeBtnClickHandler()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_SettlementNotice"))
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.viewDetailBtnClickHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ViewDetail")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.sendDLClickHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NotifyHq")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.resetSearch()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ResetFilter")))]
                    )
                  ],
                  1
                )
              ])
            ],
            2
          )
        ],
        1
      ),
      _c("bill-actual-amount-grid", {
        attrs: {
          "config-module": "410015204",
          "row-data": _vm.rowData,
          filter: _vm.filter,
          "grid-options": _vm.gridOptions
        }
      }),
      _vm.billNoticeResultWindow.visible
        ? _c("bill-notice-result-window", {
            attrs: {
              visible: _vm.billNoticeResultWindow.visible,
              "select-items": _vm.billNoticeResultWindow.selectItems
            },
            on: {
              close: function($event) {
                _vm.billNoticeResultWindow.visible = false
              },
              refresh: _vm.toQuery
            }
          })
        : _vm._e(),
      _vm.billActualAmountDetailWindow.visible
        ? _c("bill-actual-amount-detail-window", {
            attrs: {
              visible: _vm.billActualAmountDetailWindow.visible,
              "actual-amount": _vm.billActualAmountDetailWindow.actualAmount
            },
            on: {
              close: function($event) {
                _vm.billActualAmountDetailWindow.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }